// extracted by mini-css-extract-plugin
module.exports = {"Label":"Input_Label__3Odjm","LabelFull":"Input_LabelFull__n3xeo","Checkbox":"Input_Checkbox__23p8d","Input":"Input_Input___MwiR","InputError":"Input_InputError__5N-9U"};